<template>
  <div>
    <el-dialog title="编辑自我评价" :close-on-click-modal="false" :visible.sync="display" size="small" @close='closeDialog'>
      <el-input v-model="content" type="textarea" :autosize="{ minRows: 4, maxRows: 8}"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: String,
        default: {}
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        content: '',
        display: false
      };
    },
    watch: {
      data: function (value) {
        this.content = value;
      },
      visible: function (value) {
        this.display = value;
      },
    },
    mounted() {

    },
    methods: {
      cancel() {
        this.display = false;
      },
      confirm() {
        this.display = false;
        this.$emit('change', this.content);

      },
      closeDialog() {
        this.$emit('visibleChange', false);
      },
    }
  };

</script>

<style lang="scss" scoped>
</style>
